var $ = require('jquery');

L.Map.addInitHook(function () {

    var map = this, 
        $container = $('.intro');

    map.eachLayer(function(layer) {
        if (!layer.on) return;
        console.log(layer);
        layer.on({
            loading: loadStart,
            load: loadStop
        }, this);
    }, this);

    map.on('layeradd', function(e) {
        e.layer.on({
            loading: loadStart,
            load: loadStop
        }, this);
    
    }, this);

    map.on({
        dataloading: loadStart,
        dataload: loadStop,
        layerremove: loadStop
    }, this);

    function loadStart() {
        $container.addClass('loading');
    }

    function loadStop() {
        $container.removeClass('loading');
    }

});